import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import * as applicationService from "../../src/admin/services/applicationService";
import { Card } from 'primereact/card';
import Swal from 'sweetalert2';
import * as fileService from '../admin/services/fileService'
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import DateFormatter from '../Shared/DateFormatter';
import { useNavigate } from 'react-router-dom';
import { ParameterContext } from '../contexts/ParameterContext';
import { Statuses } from '../Shared/statuses';
import { RegisterContext } from '../contexts/RegisterContext';
import { checkIsOpenForAccepting, checkIsOpenForRegister } from '../admin/services/RankingService';
import { MobileContext } from '../contexts/MobileContext';
import * as request from '../admin/lib/lib'

export function Parent() {
    const { parameters } = useContext(ParameterContext);
    const { schools } = useContext(RegisterContext);
    const allcontext = useContext(AuthContext);
    const { isOnMobile } = useContext(MobileContext);

    const fullName = allcontext.user.fullName;
    const hashParrentEgn = allcontext.user.userName;

    const [loading, setLoading] = useState(false);

    const [visible, setVisible] = useState({});
    const navigate = useNavigate();

    const [data, setData] = useState('');
    const [hdata, setHdata] = useState('');
    const [sdata, setSdata] = useState('');
    const [isFinal, setIsFinal] = useState(0);
    const [isOpenForAccepting, setIsOpenForAccepting] = useState(false);
    const [isOpenForRegister, setIsOpenForRegister] = useState(false);

    let directorDisableChildData;
    if (parameters && parameters.nomParameters) {
        const directorDisableChildDataParam = parameters.nomParameters.find(x => x.param_name == 'DIR_DISABLE_CIHLD_DATA');

        directorDisableChildData = directorDisableChildDataParam ? directorDisableChildDataParam.value : 2;
    } else {
        directorDisableChildData = 2;
    }

    const handleButtonClick = (e, id, regNumUserDzId, status) => {
        e.preventDefault();

        if ((regNumUserDzId === -1 || regNumUserDzId == 0)
            || ((directorDisableChildData == 0 || directorDisableChildData == 1) && (regNumUserDzId != null && regNumUserDzId > -1))
        ) {
            Swal.fire({
                title: 'Внимание !',
                text: `Може да направите последваща редакция само ${parameters.nomParameters.find(x => x.param_name == "ADM_REG").value}!`,
                icon: 'warning',
                confirmButtonText: 'Ok'
            });

            return;
        } else if (status == 2) {
            Swal.fire({
                title: 'Внимание !',
                text: `Не можете да правите реадкция на анулирано заявление!`,
                icon: 'warning',
                confirmButtonText: 'Ok'
            });

            return;
        } else if (status == 1) {
            Swal.fire({
                title: 'Внимание !',
                text: `Не можете да правите реадкция на класирано заявление!`,
                icon: 'warning',
                confirmButtonText: 'Ok'
            });

            return;
        }

        navigate(`/parent/edit/${id}`);
    };

    useEffect(() => {
        const populate = async () => {
            setLoading(true);
            try {
                applicationService.getAllApplication(hashParrentEgn)
                    .then((res) => {
                        setData(res);
                        setLoading(false);
                    })
            } catch (error) {
                console.error('Error fetching data:', error.message);
                setLoading(false);
            }
        };

        request.get(process.env.REACT_APP_BACKEND_URL + 'Ranking/GetRecentIsFinalRanking')
            .then((data) => {
                setIsFinal(data);
            })

        checkIsOpenForAccepting()
            .then((data) => {
                setIsOpenForAccepting(data)
            })
            .catch((err) => {
                console.log(err)
            })

        checkIsOpenForRegister()
            .then((data) => {
                if (data.status === 400) {
                    setIsOpenForRegister(false);
                }
                else {
                    setIsOpenForRegister(data);
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setIsOpenForRegister(false);
                setLoading(false)
            })

        populate();
        document.title = `Прием 1 клас - община ${parameters?.municipality?.obshtina_name || ''}`;
    }, []);



    const getdataPDF = async (regId) => {
        try {
            setLoading(true);
            let downloadUrl = await fileService.getApplicationPDF({ regId });

            if (downloadUrl) {
                if (isOnMobile) {
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = 'document.pdf';
                    link.click();
                } else {
                    const newTab = window.open(downloadUrl, '_blank');
                    if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                        console.error('Error: The browser blocked opening a new tab.');
                        Swal.fire({
                            title: 'Браузърът блокира отварянето на PDF файла.',
                            text: 'Проверете настройките на браузъра си за поверителност и сигурност(Privacy & Security.),за Chrome: Изскач. прозорци и пренасочвания(Pop-ups and Redirects), за Mozilla: Разрешения(Permissions)',
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    }
                }
            }

            setLoading(false);
        } catch (error) {
            console.error('Error fetching PDF:', error);
            Swal.fire({
                title: 'Error!',
                text: error.message,
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        }
    };

    const getHistoryPdf = async (hid) => {

        const data = {
            "historyId": hid
        }

        const populate = async () => {
            try {
                setLoading(true);
                let downloadUrl = await fileService.generateHistoryPdf(data);

                if (downloadUrl) {
                    if (isOnMobile) {
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = 'document.pdf';
                        link.click();
                    } else {
                        const newTab = window.open(downloadUrl, '_blank');
                        if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                            console.error('Error: The browser blocked opening a new tab.');
                            Swal.fire({
                                title: 'Браузърът блокира отварянето на PDF файла.',
                                text: 'Проверете настройките на браузъра си за поверителност и сигурност(Privacy & Security.),за Chrome: Изскач. прозорци и пренасочвания(Pop-ups and Redirects), за Mozilla: Разрешения(Permissions)',
                                icon: 'error',
                                confirmButtonText: 'ОК'
                            })
                        }
                    }
                }

                setLoading(false);
            } catch (error) {
                console.error('Error fetching PDF:', error);
                Swal.fire({
                    title: 'Error!',
                    text: error.message,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            }
        };

        populate();
    };

    const toggleDialog = (id, openNow) => {
        setVisible(prev => ({ ...prev, [id]: !prev[id] }));

        const populate = async () => {
            try {
                applicationService.getAllApplicationHistory(id, hashParrentEgn)
                    .then((res) => {
                        setHdata(res);
                    })
            } catch (error) {
                console.error('Error fetching data:', error.message);
            }
        };

        if (openNow) {
            populate();

        }
    };


    return (
        <div>
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            {data && data.map((d, ind) => (
                <Card key={`c${d.regNumber.regnumbeR_ID}`} title={`Заявление № ${d.regNumber.regnumbeR_ID}`} subTitle={
                    `Статус: ${isFinal == 0 && d.regNumber.status == 1
                        ? Statuses[0]
                        : Statuses[d.regNumber.status]}
                        ${d.regNumber.status == 1 && isFinal == 1
                        ? ` -  ${schools.find(x => x.id == d.regNumber.dZ_ID).shortName}`
                        : ''} `
                } className="mt-5"
                >
                    <p className="m-0">
                        <div className="container">
                            <div className="row felx-mob gap-3 flex-wrap">
                                {d.regNumber.status == 0 && !isOpenForAccepting && isOpenForRegister
                                    ? <div className="col-md-3 w-100-mob p-0-mob" onClick={(e) => handleButtonClick(e, d.regNumber.regnumbeR_ID, d.regNumber.user?.dzId, d.regNumber.status)}>
                                        <Button label="Редакция" icon="pi pi-user-edit" severity="success"
                                            onClick={(e) => handleButtonClick(e, d.regNumber.regnumbeR_ID, d.regNumber.user?.dzId, d.regNumber.status)}
                                            raised className='scale btn-prim-green w-100-mob'
                                            disabled={d.regNumber.user?.dzId === -1 || d.regNumber.status == 2 || d.regNumber.status == 1} />
                                    </div>
                                    : null
                                }
                                <div className="col-md-3 pcursor w-100-mob p-0-mob">
                                    <Button label="Виж заявление" icon="pi pi-file-pdf" raised
                                        onClick={() => getdataPDF(d.regNumber.regnumbeR_ID)} className='scale btn-prim w-100-mob' />
                                </div>
                                <div className="col-md-3 w-100-mob p-0-mob">
                                    <Button label="Виж история" icon="pi pi-history" className='scale btn-hist w-100-mob' onClick={() => toggleDialog(d.regNumber.regnumbeR_ID, true)} id={`b${ind}`} />
                                    <Dialog header={`История на заявление № ${d.regNumber.regnumbeR_ID}`} visible={visible[d.regNumber.regnumbeR_ID] || false} className="w-100-mob" style={{ width: '50vw' }} onHide={() => toggleDialog(d.regNumber.regnumbeR_ID)} id={`d${ind}`}>
                                        <table className="table table-bordered table-responsive-stack mt-5">
                                            <thead>
                                                <tr>
                                                    <th className="text-rajon">Дата</th>
                                                    <th className="text-rajon">Действие</th>
                                                    <th className="text-rajon">Забележка</th>
                                                </tr>
                                            </thead>
                                            <tbody>{hdata && hdata.map((item) => (
                                                <tr key={item.id}>
                                                    <td><DateFormatter dateString={item.actioN_DATE_TIME} /></td>
                                                    <td>{item.action}</td>
                                                    <td>
                                                        {(item.actioN_ID === 0 || item.actioN_ID === 30) &&
                                                            <Button label="Виж" icon="pi pi-file-pdf" severity="danger" raised onClick={() => getHistoryPdf(item.historY_ID, hashParrentEgn)} className='scale btn-prim' />
                                                        }
                                                    </td>
                                                </tr>
                                            ))}</tbody>
                                        </table>
                                    </Dialog>
                                </div>

                            </div>
                        </div>
                    </p>

                </Card>
            ))}
            {/*<Link to="/parent/edit/10">redakciq</Link>*/}
        </div>
    );
}

export default Parent;